import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Alert, Box, Button, Card, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';

import { AdminApi } from 'api';
import { CrossIcon } from 'components';
import { TableSkeleton } from 'components/common/skeletons';
import { ButtonComponent } from 'components/ui';
import { usePageTitle } from 'helpers/hooks';
import { squareBtnStyle } from '../dashboard/trialUnitsOrders';
import { AddDomain } from './addDomain';
import { DeleteDomainModal } from './deleteDomain';

export const AppSettings = () => {
  usePageTitle('Datai API Panel · App Settings');
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [removeDomain, setRemoveDomain] = useState('');

  const toggleModal = () => setModalOpen(!modalOpen);

  const onConfirmRemove = (str) => () => setRemoveDomain(str);

  const renderDomains = () =>
    data.map((el, index) => (
      <TableRow key={'row-' + index + Math.random() + el} sx={{ height: 57 }}>
        <TableCell {...{ component: 'th', scope: 'row', sx: { paddingLeft: 4 } }}>
          <Typography variant='body1'>{el || '-'}</Typography>
        </TableCell>
        <TableCell {...{ component: 'th', scope: 'row' }} align='right'>
          <Button size='small' variant='outlined' color='error' sx={{ ...squareBtnStyle }} onClick={onConfirmRemove(el)}>
            <CrossIcon />
          </Button>
        </TableCell>
      </TableRow>
    ));

  const getDomains = () => {
    setError('');
    setLoading(true);
    AdminApi.getBlackListDomains()
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getDomains();
  }, []);

  return (
    <Fragment>
      <Card sx={{ paddingTop: 3, paddingBottom: 6 }} variant='outlined'>
        <Grid sx={{ marginBottom: 2, paddingX: 4 }} container justifyContent='space-between'>
          <Typography variant='h4'>Black List Email Domains</Typography>
          <ButtonComponent disabled={loading || error} height={32} width={193} text='Add' onClick={toggleModal} endIcon={<ControlPointIcon fontSize='small' />} />
        </Grid>
        {loading ? (
          <TableSkeleton tHeadHeight={56.5} rowHeight={57} />
        ) : error ? (
          <Box sx={{ paddingX: 4 }}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        ) : !data.length ? (
          <Box sx={{ paddingX: 4 }}>
            <Alert severity='info'>No Info</Alert>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ paddingLeft: 4 }}>
                  <Typography variant='caption' color='text.secondary'>
                    Domain
                  </Typography>
                </TableCell>
                <TableCell align='right' sx={{ width: 100 }}>
                  <Typography variant='caption' color='text.secondary'>
                    Delete
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderDomains()}</TableBody>
          </Table>
        )}
      </Card>
      <AddDomain key={`add-domain-blacklist-${String(modalOpen)}`} updateDomais={getDomains} open={modalOpen} onCloseModal={toggleModal} />
      <DeleteDomainModal key={`delete-domain-blacklist-${removeDomain}`} domain={removeDomain} updateDomains={getDomains} open={!!removeDomain} setRemoveDomain={setRemoveDomain} />
    </Fragment>
  );
};
